// Japanese (`ja`) shell baseline
import { layoutJa } from './ja/layout'
import { homeJa } from './ja/home'
import { playJa } from './ja/play'
import { demoJa } from './ja/demo'
import { booksJa } from './ja/books'
import { commerceJa } from './ja/commerce'
import { communityJa } from './ja/community'
import { dashboardJa } from './ja/dashboard'
import { authJa } from './ja/auth'
import { marketingJa } from './ja/marketing'
import { worldJa } from './ja/world'
import { encyclopediaJa } from './ja/encyclopedia'
import { systemJa } from './ja/system'
import { cityJa } from './ja/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseJa: MessageCatalog = {
  ...layoutJa,
  ...homeJa,
  ...playJa,
  ...demoJa,
  ...booksJa,
  ...commerceJa,
  ...communityJa,
  ...dashboardJa,
  ...authJa,
  ...marketingJa,
  ...worldJa,
  ...encyclopediaJa,
  ...systemJa,
  ...cityJa,
}
